module.exports = __webpack_public_path__ + "img/area-add-2-02.930393f.jpg";